/**
 * API 端點常數
 * 集中管理所有 API 路徑
 */

export const ENDPOINTS = {
  // ========== 點燈活動相關 ==========
  LAMP: {
    // 取得點燈列表
    LIST: '/lamp/list',
    // 取得點燈詳情
    DETAIL: (id) => `/lamp/${id}`,
    // 取得點燈時程表
    SCHEDULE: '/lamp/schedule',
    // 取得智慧之燈頁面資料
    WISDOM: '/lamp/wisdom',
    // 提交點燈表單
    SUBMIT: '/lamp/submit',
    // 取得點燈佈告欄
    BULLETIN: '/lamp/bulletin',
    // 取得祈福結果
    BLESSING_RESULT: (id) => `/lamp/blessing/${id}`,
    // 取得傳燈時程列表
    PERIOD_LIST: '/v1/lighting/period/list',
    // 取得傳燈區域精舍列表
    REGION_LIST: '/v1/lighting/region/list',
    // 取得祈願類別列表
    VOW_CATEGORY_LIST: '/v1/vow/category/list',
    // 取得祈願記錄列表
    VOW_RECORD_LIST: '/v1/vow/record/list',
    // 新增祈願記錄
    VOW_RECORD_ADD: '/v1/vow/record/add',
    // 取得祈願記錄詳細描述
    VOW_RECORD_DESCRIBE: '/v1/vow/record/describe',
    // 取得傳燈報導列表
    LIGHTING_POST_LIST: '/v1/lighting/post/list',
    // 精舍報導按讚
    LIGHTING_POST_LIKE: '/v1/lighting/post/like',
  },

  // ========== 精舍報導相關 ==========
  BRANCH: {
    // 取得精舍列表
    LIST: '/branch/list',
    // 取得精舍詳情
    DETAIL: (id) => `/branch/${id}`,
    // 取得焦點精舍
    FEATURED: '/branch/featured',
    // 取得地區精舍
    REGIONS: '/branch/regions',
  },

  // ========== 首頁相關 ==========
  HOME: {
    // 取得輪播圖
    SLIDES: '/home/slides',
    // 取得新聞列表
    NEWS: '/home/news',
    // 取得影片列表
    VIDEOS: '/home/videos',
    // 取得互動專區項目
    INTERACTIVE: '/home/interactive',
    // 取得首頁所有資料
    ALL: '/home/all',
  },

  // ========== 個人資料相關 ==========
  PROFILE: {
    // 取得個人資料
    DESCRIBE: '/v1/member/profile/describe',
    UPDATE: '/v1/member/profile/edit',
    // 取得實體互動活動列表
    ACTIVITY_LIST: '/v1/member/profile/activity/list',
    // 取得文星點燈列表
    LIGHTING_POST_LIST: '/v1/member/profile/lightingPost/list',
    // 取得護法DNA列表
    DNA_LIST: '/v1/member/profile/psycho/result',
    // 取得禪心連線列表
    BOARD_LIST: '/v1/member/profile/board/list',
    // 取得明信片列表
    POSTCARD_LIST: '/v1/member/profile/postcard/list',
    // 取得明信片詳細描述 111 member020 //114 interact016
    POSTCARD_DESCRIBE: '/v1/member/profile/postcard/describe',
    POSTCARD_ITEM_CATEGORY: '/v1/interact/postcard/item/category',
    // 積分互送列表
    POINT_TX_LIST: '/v1/member/profile/pointTX/list',
    // 庭影覺光列表
    SHADOWS_LIST: '/v1/member/profile/shadows/list',
    // 中台心傳按讚列表
    EXHIBITION_POST_LIST: '/v1/member/profile/exhibitionPost/list',
    // 取得願心樹發願詳細描述 168 member027
    EXHIBITION_VOW_DESCRIBE: '/v1/member/profile/exhibitionVow/describe',
    // 取得願心樹發願列表
    EXHIBITION_VOW_LIST: '/v1/member/profile/exhibitionVow/list',
  },

  // ========== 認證相關 ==========
  AUTH: {
    // 取得 Viewer Token
    VIEWER_TOKEN: '/v1/auth/viewerToken/get',
    // 會員註冊
    REGISTER: '/v1/auth/member/register',
    // 會員登入
    LOGIN: '/v1/member/auth/login',
    // 檢查會員通知（未註冊者顯示積分提醒）
    MEMBER_CHECK: '/v1/auth/member/check',
  },

  // ========== 精舍相關 ==========
  MONASTERY: {
    // 取得精舍列表
    LIST: '/v1/member/monastery/list',
  },

  // ========== 花絮相關 ==========
  BEHIND_SCENES: {
    LIST: '/v1/event/behindScenes/list',
  },

  // ========== Banner 相關 ==========
  BANNER: {
    // 取得 Banner 列表
    LIST: '/v1/member/banner/list',
    // 依活動取得 Banner
    LIST_BY_EVENT: '/v1/member/banner/listByEvent',
  },

  // ========== 中台心傳 / 展覽相關 ==========
  EXHIBITION: {
    AREA_LIST: '/v1/exhibition/area/list',
    REGION_LIST: '/v1/exhibition/region/list',
    POST_LIST: '/v1/exhibition/post/list',
    POST_LIKE: '/v1/exhibition/post/like',
    COORDINATE_LIST: '/v1/exhibition/coordinate/list',
  },

  // ========== 最新消息 / 最新影音 ==========
  LATEST_NEWS: {
    LIST: '/v1/interact/latest/news/list',
    DETAIL: '/v1/latest/news/postDescribe',
  },

  // ========== 禪心連線（實況留言板）相關 ==========
  LIVE_COMMENT: {
    BOARD_LIST: '/v1/interact/board/list',
    TOPIC_LIST: '/v1/interact/board/topic/list',
    COMMENT_LIST: '/v1/comment/list',
    COMMENT_POLLING_LIST: '/v1/comment/polling/list',
    COMMENT_ADD: '/v1/comment/add',
    COMMENT_LIKE: '/v1/comment/like',
  },

  // ========== 教理問答相關 ==========
  QUIZ: {
    // 篇章列表
    // 34 interact001 System, Member, Viewer
    i34_CHAPTER_LIST: '/v1/interact/buddhist/chapter/list',
    // 篇章題目列表
    // 35 interact002 Member
    i35_LIST: `/v1/interact/buddhist/question/listByChapter`,
    // 題目答案確認
    // 36 interact003 Member
    i36_ANSWER: `/v1/interact/buddhist/question/answer`,
    // 75 interact006 Member, Viewer
    i75_SCORE: '/v1/interact/buddhist/question/score',
  },

  // ========== 積分兌換相關 ==========
  POINT_EX: {
    // 取得可兌換項目列表
    ITEMS_LIST: '/v1/pointEx/items/list',
    // 吉祥物
    M08_MASCOT_LIST: '/v1/member/profile/mascot/list',
    // 點燈
    M09_VOW_LIST: '/v1/member/profile/vow/list',
    VOW005_VOW_DESCRIBE: '/v1/vow/record/listByOwned',
    // 中台知多少分數列表
    M10_BUDDHIST_LIST: '/v1/member/profile/buddhist/list',
  },

  // ========== QR Code 相關 ==========
  QRCODE: {
    // x 52 activity004 System 
    // i52_EVENT: '/v1/activity/official/get',
    // x 56 activity008 System, Admin, Root, Monastery
    // i56_EVENT_CHECKIN: '/v1/activity/system/record/add',

    // 用戶產生qrcode頁面
    // 54 activity003 Member, Viewer
    i54_USER_CODE: '/v1/activity/user/getCode',
    // 用戶開掃描器，掃描活動qrcode頁面
    // 55 activity004 Member, Viewer
    i55_USER_CKECKIN: '/v1/activity/user/record/add',
    // 跳出「報到成功 or 轉點成功」提醒
    // 95 activity007 Member, Viewer
    i95_USER_CHECK: '/v1/activity/user/record/check',
  },

  // ========== 心理測驗護法DNA ==========
  DNA: {
    // 獲得題目、答案、結算結果
    // 80 interact010 Member, Viewer
    i80_QUESTION: '/v1/interact/psycho/question/get',
    // 儲存受測者答案
    // 81 interact011 Member, Viewer
    i81_SAVE: '/v1/interact/psycho/answer/save',
    // 計算測驗結果
    // 82 interact012 Member, Viewer
    i82_CALCULATE: '/v1/interact/psycho/result/calculate',
    // 開始新的測驗
    // 83 interact013 Member, Viewer
    i83_RESTART: '/v1/interact/psycho/restart',
    // 獲得測驗歷史紀錄
    // 84 interact014 Member, Viewer
    i84_HISTORY: '/v1/interact/psycho/history/get',
  },
  // ========== 兌換積分相關 ==========
  REDEEM: {
    // 列出用戶擁有的兌換券
    m16_VOUCHER_LIST: '/v1/member/profile/voucher/list',
    // 列出用戶的兌換券可兌換的吉祥物
    m17_VOUCHER_MASCOT_LIST: `/v1/member/voucher/exchangeable/list`,
    // 用戶使用兌換券
    m18_EXCHANGE: `/v1/member/voucher/exchange`,
    // 兌換
    MASCOT_EXCHANGE: `/v1/pointEx/items/exchange`,
  },

  // ========== 實體禮物兌換（特別獎勵）相關 ==========
  PHYSICAL_GIFT: {
    // 兌換規則列表（含是否符合資格 / 是否已兌換）
    EXCHANGE_RULE_LIST: '/v1/member/physicalGift/exchangeRule/list',
    // 取得兌換碼
    EXCHANGE_RULE_GET_CODE: '/v1/member/physicalGift/exchangeRule/getCode',
    // 取得兌換紀錄結果
    RECORD_RESULT: '/v1/member/physicalGift/record/result',
  },

  // ========== 願心樹相關 ==========
  WISH_TREE: {
    i165_CONTENT_LIST: '/v1/exhibitionVow/content/list',
    i166_RECORD_ADD: '/v1/exhibitionVow/record/add',
    i167_RECORD_DESCRIBE: '/v1/exhibitionVow/record/describe',
    i171_RECORD_COUNT: '/v1/exhibitionVow/record/count',
  },

  // ========== 護博會 ==========
  GUARDIAN_EXPO: {
    // 挑戰賽賽程表
    CHALLENGE_LIST: '/v1/expo/challenge/list',
    // 挑戰賽總冠軍／亞軍／季軍名次
    CHALLENGE_RANK_LIST: '/v1/expo/challenge/rankList',
    // 活動影音／活動圖片列表
    MEDIA_LIST: '/v1/expo/media/list',
    CHALLENGE_RANK: '/v1/expo/challenge/rankList',
    // 博覽會資訊（報到通知／其他公告）列表
    NOTIFICATION_LIST: '/v1/expo/notification/list',
  },

  // ========== 飄落彩蛋抽獎（點擊蓮花/菩提葉加分）相關 ==========
  LOTTERY: {
    // 取得抽獎狀態（是否有可領取的獎勵）
    STATUS: '/v1/point/lottery/status',
    // 領取獎勵（加分）
    CLAIM: '/v1/point/lottery/claim',
  },
};

export default ENDPOINTS;
